import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.937 6.033a.7.7 0 0 0-.993-.987l-.77.774-.28-.282a.7.7 0 1 0-.993.988l.777.78a.7.7 0 0 0 .992 0l1.267-1.273Zm1.589-.463a.7.7 0 1 0 0 1.4h7.076a.7.7 0 1 0 0-1.4H8.526Zm0 3.735a.7.7 0 1 0 0 1.4h7.076a.7.7 0 1 0 0-1.4H8.526Zm0 3.736a.7.7 0 1 0 0 1.4h7.076a.7.7 0 1 0 0-1.4H8.526ZM6.937 9.869a.7.7 0 0 0-.993-.988l-.77.775-.28-.282a.7.7 0 0 0-.993.988l.777.78a.7.7 0 0 0 .992 0L6.937 9.87Zm-.003 2.822a.7.7 0 0 1 .003.99L5.67 14.955a.7.7 0 0 1-.992 0l-.777-.781a.7.7 0 1 1 .993-.987l.28.281.77-.774a.7.7 0 0 1 .99-.003Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
